import { Theme } from "Components/Themes/themeInterfaces";
import { isDefined } from "Utils/functions";
import styled from "styled-components";

interface OuterProps {
  space: string;
  borderRadius?: string;
}
export const OuterWrapper = styled.section<OuterProps>`
  background-color: white;
  border-radius: ${({ borderRadius }) => borderRadius ?? "0"};
  padding: ${({ space }) => space} 0;
`;

interface InnerProps {
  theme: Theme;
  coverageDetailsCard: boolean;
  insuranceDetailsCard: boolean;
  dynamicInsuranceDetailsCard: boolean;
  adviceDetailsCard: boolean;
  additionalCoverage: boolean;
  padding: string;
  selected: boolean | undefined;
  disabled: boolean | undefined;
}

const getBackgroundColor = ({
  theme: {
    brandColors,
    insuranceDetailsCard: { notSelectedBackgroundColor, backgroundColor },
  },
  coverageDetailsCard,
  insuranceDetailsCard,
  dynamicInsuranceDetailsCard,
  selected,
}: InnerProps): string => {
  const isSelected =
    insuranceDetailsCard || (dynamicInsuranceDetailsCard && selected === true);

  if (isSelected) {
    return backgroundColor;
  }
  if (coverageDetailsCard) {
    return notSelectedBackgroundColor || brandColors.white;
  }
  return brandColors.white;
};

const getBorderColor = (props: InnerProps): string => {
  if (props.dynamicInsuranceDetailsCard) {
    if (isDefined(props.disabled) && props.disabled) {
      return props.theme.borderDisabled;
    } else if (
      props.additionalCoverage ||
      (isDefined(props.selected) &&
        !isDefined(props.theme.insuranceDetailsCard.notSelectedBackgroundColor))
    ) {
      return props.theme.insuranceDetailsCard.border;
    }
  } else if (props.adviceDetailsCard && isDefined(props.selected)) {
    return `4px ${props.selected ? "solid" : "dashed"} ${
      props.theme.insuranceDetailsCard?.backgroundColor ??
      props.theme.brandColors.surface.variant
    }`;
  }
  return props.selected ? "1px solid var(--p-color-stroke-strong)" : "none";
};

const getColor = (props: InnerProps): string => {
  if (
    props.insuranceDetailsCard ||
    (props.dynamicInsuranceDetailsCard && props.selected === true)
  ) {
    return props.theme.insuranceDetailsCard.textColor;
  }
  return props.theme.brandColors.black;
};

export const InnerWrapper = styled.section<InnerProps>`
  background-color: ${(props) => getBackgroundColor(props)};
  border: ${(props) => getBorderColor(props)};
  border-radius: ${({ theme }) => theme.borderRadius.smallRounding};
  box-sizing: border-box;
  color: ${(props) => getColor(props)};
  overflow: hidden;
  padding: ${({ padding }) => padding};
`;
